/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import { Checkbox as AntdCheckbox } from 'antd'

const StyledCheckbox = styled(AntdCheckbox)`
  .ant-checkbox + span {
    padding-left: 12px;
  }
  border-width: 2px;
  .ant-checkbox-wrapper {
    padding: 5px !important;
  }
`
const LabelWrapper = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #999fac;
`

const Checkbox = ({ onChange, label, value, name, rules, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} checked={value}>
      <LabelWrapper>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default Checkbox
